// Where every "Start your Tribzz" button on the GymDesk Suite site points.
// Change this one line when Tribzz's public address is final (or point it
// straight at the "Start one" screen once that has a stable link).
export const TRIBZZ_URL = 'https://tribzz.com'
export const TRIBZZ_START_URL = TRIBZZ_URL